import { type ActionTypes } from '~/actions';
import { ActionKeys } from '~/actions/constants';
import { type FeatureTestVariant } from '~/types/FeatureTest';

export type FeatureTestsState = {
  testVariantByFeature: { [testName: string]: FeatureTestVariant };
};

const initialState: FeatureTestsState = {
  testVariantByFeature: {},
};

const featureTestsReducer = (
  state: FeatureTestsState = initialState,
  action: ActionTypes,
): FeatureTestsState => {
  switch (action.type) {
    case ActionKeys.FETCH_AB_TEST_FEATURES:
      return {
        ...state,
      };
    case ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS:
      return {
        ...state,
        testVariantByFeature: action.payload.featureTestUserVariants.reduce(
          (map, variant) => ({
            ...map,
            [variant.featureTest.name]: variant.featureTestVariant,
          }),
          {},
        ),
      };
    default:
      return state;
  }
};

export default featureTestsReducer;
